module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/USB-834e943cbcc0c5da6e791f2ad86ca366.svg";